<template>
	<el-row>
		<div v-if="materialPicVos.length > 0">
			<h1>图片，视频</h1>
			<div class="box" v-for="(item, index) in materialPicVos" :key="index">
				<div class="date">
					{{ item.createTime }}
				</div>
				<div style="margin-top: 10px;">
					<div style="width: 50%;display: flex;">
						<div style="width: 25%;">
							<img :src="tx" width="auto" height="50px" />
						</div>
						<div style="width: auto;margin-left: 10px;">
							{{ $route.query.festivalName }}
						</div>
					</div>
					<div style="margin-left: 5%;margin_top:20px;width: 30%;">
						<div v-if="item.materialType == '02'">
							<div style="height: 50px; line-height: 50px">
								###商品主图
							</div>
							<el-upload :class="{ hide: true }" action="" :file-list="item.imgUrl"
								list-type="picture-card" :disabled="true"></el-upload>
						</div>
						<div v-if="item.materialType == '03'">
							<div style="height: 50px; line-height: 50px">
								### 图片
							</div>
							<el-image :src="item.url" style="height: 200px"></el-image>
							<div>
								图片描述：{{ item.description ? item.description : '无' }}
							</div>
						</div>
						<div v-if="item.materialType == '04'">
							<div style="height: 50px; line-height: 50px">
								### 视频
							</div>
							<video width="300px" height="200px" :src="item.url" controls></video>
						</div>
					</div>
				</div>
				<div style="text-align: center;width: 25%;">
					<el-button @click="delList(item)" type="text" icon="el-icon-delete" style="color: #df3b54;">
						删除</el-button>
					<el-button @click="editorList(item)" type="text" icon="el-icon-circle-plus-outline">
						<strong>编辑</strong>
					</el-button>
				</div>
			</div>
		</div>
		<div v-if="paragraphVos.length > 0">
			<!-- <h1>圈文，富文本，段落</h1> -->
			<h1>圈文</h1>
			<div class="box" v-for="(item, index) in paragraphVos" :key="index">
				<div class="date">
					{{ item.createTime }}
				</div>
				<div style="margin-top: 10px;">
					<div style="width: 50%; height: 50px;display: flex;">
						<div style="width: 25%;">
							<img :src="tx" width="auto" height="100%" />
						</div>
						<div style="width: auto;margin-left: 20px;">
							{{ $route.query.festivalName }}
						</div>
					</div>
					<div style="margin-left: 5%;width: 50%;margin-top: 30px;">
						<div v-if="item.paragraphType == '01'">
							<div style="height: 50px; line-height: 50px">
								### 内容段落
							</div>
							<el-form label-position="right" label-width="100px" style="margin-top: 10px">
								<el-form-item label="标题:">{{ item.title }}</el-form-item>
								<el-form-item label="段落">
									<div v-for="(item2, index2) in item.paragraph2">
										<el-form-item>{{ item2 }}</el-form-item>
									</div>
								</el-form-item>
							</el-form>
						</div>
						<div v-if="item.paragraphType == '02'">
							<div style="height: 50px; line-height: 50px">
								### 富文本
							</div>
							<div style="margin-top: 10px">
								<div v-html="item.paragraph"></div>
								<!-- <wangeditor v-model="item.paragraph"></wangeditor> -->
							</div>
						</div>
						<div v-if="item.paragraphType == '03'">
							<div style="height: 50px; line-height: 50px">
								### 圈文
							</div>
							<span>{{ item.paragraph }}</span>
							<div v-if="item.type2 == 0" style="width: 70%;">
								<el-upload :class="{ hide: true }" action="" :file-list="item.imgUrl"
									list-type="picture-card" :disabled="true"></el-upload>
							</div>
							<div v-if="item.type2 == 1">
								<video width="300px" height="200px" :src="item.paragraphUrl" controls></video>
							</div>
						</div>
					</div>
				</div>
				<div style="text-align: center;width: 25%;">
					<el-button @click="delList(item)" type="text" icon="el-icon-delete" style="color: #df3b54;">
						删除
					</el-button>
					<el-button @click="editorList(item)" type="text" icon="el-icon-circle-plus-outline">编辑
					</el-button>
				</div>
			</div>
		</div>
		<div v-if="festivalCommodityVos.length > 0">
			<h1>节日款商品</h1>
			<div class="box" v-for="(item, index) in festivalCommodityVos" :key="index">
				<div class="date">
					{{ item.createTime }}
				</div>
				<div style="margin-top: 10px;">
					<div style="width: 20%; height: 50px;display: flex;">
						<div style="width: 25%;">
							<img :src="tx" width="auto" height="100%" />
						</div>
						<div style="width: auto;;">
							{{ $route.query.festivalName }}
						</div>
					</div>
					<div style="margin-left: 5%;margin-top:10px;width: 30%;">
						<div style="height: 50px; line-height: 50px">
							### 节日款商品
						</div>
						<el-form label-position="right" label-width="100px" style="width: 700px">
							<el-form-item label="商品ID">{{ item.commodityId }}</el-form-item>
							<el-form-item label="商品图片">
								<img :src="item.commodityPic" height="200px" />
							</el-form-item>
							<el-form-item label="商品标题">{{ item.commodityTitle }}</el-form-item>
							<el-form-item label="商品售价">{{ item.commodityPrices }}</el-form-item>
						</el-form>
					</div>
				</div>
				<div style="text-align: center;width: 25%;">
					<el-button @click="delList(item)" type="text" icon="el-icon-delete" style="color: #df3b54;">
						删除</el-button>
					<el-button @click="editorList(item)" type="text" icon="el-icon-circle-plus-outline">
						编辑
					</el-button>
				</div>
			</div>
		</div>
		<div v-if="chatScriptVos.length > 0">
			<!-- <h1>聊天话术</h1> -->
			<div class="box" v-for="(item, index) in chatScriptVos" :key="index">
				<div class="date">
					{{ item[0].createTime }}
				</div>
				<div style="margin-top: 10px;">
					<div style="width: 20%; height: 50px;display: flex;">
						<div style="width: 25%;">
							<img :src="tx" width="auto" height="100%" />
						</div>
						<div style="width: auto;overflow: hidden; text-overflow: ellipsis;white-space: nowrap;">
							{{ $route.query.festivalName }}
						</div>
					</div>
					<div style="margin-left: 5%;width: 30%;">
						<div style="height: 50px; line-height: 50px">
							--- 聊天话术
						</div>
						<div v-for="(item2, index2) in item" style="width: 700px; background-color: #fff">
							<div v-if="item2.chatType == '01'"
								style="width: 100%;display: flex;align-items: center;justify-content: flex-start;">
								<img src="https://xinian.oss-cn-beijing.aliyuncs.com/smallProgram/hunianimg/sx/05.png"
									width="90px" height="90px" />
								{{ item2.chatContent }}
							</div>
							<div v-if="item2.chatType == '02'"
								style="width: 100%;display: flex;align-items: center;justify-content: flex-end;">
								{{ item2.chatContent }}
								<img src="https://xinian.oss-cn-beijing.aliyuncs.com/smallProgram/hunianimg/sx/03.png"
									width="90px" height="90px" />
							</div>
						</div>
					</div>
				</div>
				<div style="text-align: center;width: 25%;">
					<el-button @click="delList(item)" type="text" icon="el-icon-delete" style="color: #df3b54;">
						删除</el-button>
					<el-button @click="editorList(item)" type="text" icon="el-icon-circle-plus-outline">编辑
					</el-button>
				</div>
			</div>
		</div>
		<el-button style="width: 100px;height: 100px;position: fixed;top: 40%;right: 100px;" type="danger"
			@click="addList">添加+
		</el-button>
		<el-dialog :visible.sync="dialogVisible" :title="title" center width='70%'>
			<el-form ref="info" :model="info" :rules="infoRules" label-position="right" label-width="110px">
				<el-form-item label="素材类型">
					<div style="display: flex;">
						<el-tag :class="chooseType == item.value ? 'tag2' : 'tag'" v-for="(item, index) in typeList"
							:key="index" @click="choose(item)" :disabled='true'
							:style="title == '编辑发布信息' ? 'pointer-events: none' : 'pointer-events: auto'">
							{{ item.label }}
						</el-tag>
					</div>
				</el-form-item>
				<template v-if="chooseType == 1">
					<el-form-item label="上传主图" prop="url1">
						<el-button @click="openImg(1)" type="primary" style="margin-bottom: 10px;" size="mini">图片库上传
						</el-button>
						<el-upload :class="{ hide: true }" :action="action" list-type="picture-card" :limit="1"
							:on-success="getPictrueURL" accept=".jpg,.png" :file-list="fileList"
							:on-preview="handlePictureCardPreview" :on-remove="handleRemove">
							<i class="el-icon-plus" />
						</el-upload>
						<el-dialog :visible.sync="dialogDisplay" size="tiny" @close="imagePrevClosed"
							:append-to-body="true">
							<el-image width="100%" :src="dialogImageUrl"></el-image>
						</el-dialog>
						<span>png/jpg格式，限一张</span>
					</el-form-item>
					<el-form-item label="图片描述" prop="description">
						<el-input type="textarea" v-model="info.description" maxlength="100" show-word-limit></el-input>
					</el-form-item>
				</template>
				<template v-if="chooseType == 2">
					<el-form-item label="上传视频" prop="video2">
						<el-upload :action="action" list-type="picture-card" :limit="1" :on-success="getPictrueURL"
							accept=".mp4" v-if="info.video2 == ''">
							<i class="el-icon-plus" />
						</el-upload>
						<div style="display: flex" v-if="info.video2 != ''">
							<video :src="info.video2" width="300px" height="200px" controls></video>
							<div style="display: flex; align-items: center">
								<el-button type="text" icon="el-icon-delete-solid" @click="handleRemove()">
								</el-button>
							</div>
						</div>
						<span>mp4格式，限一条</span>
					</el-form-item>
				</template>
				<template v-if="chooseType == 3">
					<el-form-item label="内容信息" prop="title3">
						<el-input type="textarea" v-model="info.title3" maxlength="5000" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="上传">
						<el-select v-model="value" @change="chooseValue">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="value == 0" prop="url3">
						<!-- <el-radio-group v-model="radioValue" @input="chooseRadio(9)">
							<el-radio :label="0">本地上传</el-radio>
							<el-radio :label="1">图片库上传</el-radio>
						</el-radio-group> -->
						<el-button @click="openImg(9)" type="primary" v-if="fileList.length<9">图片库上传</el-button>
						<el-upload :class="{ hide: true }" :action="action" list-type="picture-card"
							:file-list="fileList" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
							v-if="fileList.length>0">
							<i class="el-icon-plus" />
						</el-upload>
						<el-dialog :visible.sync="dialogDisplay" size="tiny" @close="imagePrevClosed"
							:append-to-body="true">
							<el-image width="100%" :src="dialogImageUrl"></el-image>
						</el-dialog>
						<div>png/jpg格式，限9张</div>
					</el-form-item>
					<el-form-item v-if="value == 1" prop="video3">
						<el-upload :class="{ hide: hideUpload }" :action="action" list-type="picture-card"
							:on-success="getPictrueURL" accept=".mp4" v-if="info.video3 == ''">
							<i class="el-icon-plus" />
						</el-upload>
						<div style="display: flex" v-if="info.video3 != ''">
							<video width="300px" height="200px" :src="info.video3" controls></video>
							<div style="display: flex; align-items: center; margin-left: 10px">
								<el-button icon="el-icon-delete" @click="handleRemove()" size="small" type="primary">
								</el-button>
							</div>
						</div>
						<span>mp4格式，限1条</span>
					</el-form-item>
				</template>
				<template v-if="chooseType == 4">
					<div v-for="(item, index) in info.arr4">
						<el-form-item label="商品主图" :prop="`arr4.${index}.commodityPic`" :rules="[{
							required: true, message: '请上传商品主图', trigger: 'blur',
						}]">
							<el-upload :class="{ hide: hideUpload }" :action="action" list-type="picture-card"
								:limit="1" :on-success="getPictrueURL2.bind(null, { index: index, data: item })"
								accept=".jpg,.png" :file-list="info.arr4[index].commodityPic"
								:on-remove="handleRemove2.bind(null, { index: index, data: item })"
								v-if="info.arr4[index].commodityPic.length == 0">
								<i class="el-icon-plus" />
							</el-upload>
							<div style="display: flex; align-items: center"
								v-if="info.arr4[index].commodityPic.length > 0">
								<el-image style="width: 150px; height: 150px"
									:src="info.arr4[index].commodityPic[0].url"></el-image>
								<div style="margin-left: 20px">
									<el-button icon="el-icon-delete" size="small" @click="delCon(index, '4s')"
										type="primary">
									</el-button>
								</div>
							</div>
							<span>png/jpg格式，限一张</span>
						</el-form-item>
						<el-form-item label="商品标题" :prop="`arr4.${index}.commodityTitle`" :rules="[{
							required: true, message: '请输入商品标题', trigger: 'blur',
						}]">
							<el-input type="textarea" maxlength="50" show-word-limit v-model="item.commodityTitle">
							</el-input>
						</el-form-item>
						<el-form-item label="商品售价" :prop="`arr4.${index}.commodityPrices`" :rules="[{
							required: true, message: '请输入正确售价', trigger: 'blur',
						}]">
							<el-input v-model="item.commodityPrices" type="number" min="0"></el-input>
						</el-form-item>
						<el-form-item label="商品id" :prop="`arr4.${index}.commodityId`" :rules="[{
							required: true, message: '请输入商品id', trigger: 'blur',
						}]">
							<el-input v-model="item.commodityId" type="number"> </el-input>
						</el-form-item>
						<el-form-item v-if="isShow2">
							<el-button @click="delCon(index, 4)" icon="el-icon-delete" type="text"
								v-if="info.arr4.length > 1">
							</el-button>
							<el-button @click="addCon(4)" type="text" v-if="index == info.arr4.length - 1">再加一个商品
							</el-button>
						</el-form-item>
					</div>
				</template>
				<template v-if="chooseType == 5">

				</template>
				<template v-if="chooseType == 6">
					<el-form-item label="上传主图" prop="url6">
						<el-radio-group v-model="radioValue" @input="chooseRadio(9)">
							<el-radio :label="0">本地上传</el-radio>
							<el-radio :label="1">图片库上传</el-radio>
						</el-radio-group>
						<el-upload :class="{ hide: hideUpload }" :action="action" list-type="picture-card" :limit="9"
							:on-success="getPictrueURL" accept=".jpg,.png" :file-list="fileList"
							:on-preview="handlePictureCardPreview" :on-remove="handleRemove" :multiple="true">
							<i class="el-icon-plus" />
						</el-upload>
						<el-dialog :visible.sync="dialogDisplay" size="tiny" @close="imagePrevClosed"
							:append-to-body="true">
							<el-image width="100%" :src="dialogImageUrl"></el-image>
						</el-dialog>
						<span>png/jpg格式，限九张</span>
					</el-form-item>
				</template>
				<template v-if="chooseType == 7">
					<el-form-item label="内容标题" prop="title7">
						<el-input show-word-limit maxlength="50" v-model="info.title7"></el-input>
					</el-form-item>
					<div v-for="(item, index) in info.arr7">
						<el-form-item label="内容段落" :prop="`arr7.${index}.paragraph7`" :rules="[{
							required: true, message: '请输入内容段落', trigger: 'blur',
						}]">
							<el-input type="textarea" v-model="item.paragraph7" show-word-limit maxlength="5000">
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button @click="delCon(index, 6)" icon="el-icon-delete" type="text"
								v-if="info.arr7.length > 1">
							</el-button>
							<el-button @click="addCon(6)" type="text" v-if="index == info.arr7.length - 1">再来一段
							</el-button>
						</el-form-item>
					</div>
				</template>
				<template v-if="chooseType == 8">
					<el-form-item label="富文本" prop="title8">
						<wangeditor v-model="info.title8"></wangeditor>
					</el-form-item>
				</template>
				<template v-if="chooseType == 9">
					<div style="width: 80%; height: 100%; margin: 0 auto" v-for="(item, index) in info.arr9"
						:key="index">
						<div v-if="item.chatType == '01'"
							style="display: flex;align-items: center;justify-content: flex-start;">
							<img src="https://xinian.oss-cn-beijing.aliyuncs.com/smallProgram/hunianimg/sx/05.png"
								width="90px" height="90px" />
							<el-input v-model="item.chatContent" style="width: 82%"></el-input>
							<el-button @click="del(item, index)" icon="el-icon-delete-solid" type="text">
							</el-button>
						</div>
						<div v-if="item.chatType == '02'"
							style="display: flex;align-items: center;justify-content: flex-end;">
							<el-button @click="del(item, index)" icon="el-icon-delete" type="text"></el-button>
							<el-input v-model="item.chatContent" style="width: 82%"></el-input>
							<img src="https://xinian.oss-cn-beijing.aliyuncs.com/smallProgram/hunianimg/sx/03.png"
								width="90px" height="90px" />
						</div>
					</div>
					<div style="width: 80%;height: 100%;margin: 0 auto; display: flex;justify-content: space-between;">
						<el-button @click="add(1)" type="text"> 左面加一条</el-button>
						<el-button @click="add(2)" type="text"> 右面加一条</el-button>
					</div>
				</template>
				<el-form-item>
					<el-button type="infor" @click="dialogVisible = false">取消</el-button>
					<el-button type="primary" @click="sumbit()">确认</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-drawer title="选择图片" :visible.sync="isSelectPicture" direction="rtl" size="40%">
			<SelectPicture :imgNum="imgNum" @imgList='getImg' />
		</el-drawer>
	</el-row>
</template>

<script>
	import httpClient from '../../../util/request.js';
	import wangeditor from "../../../components/wangEditor/wangEditor.vue";
	import SelectPicture from '../../../components/SelectPicture/index.vue'
	export default {
		components: {
			wangeditor,
			SelectPicture
		},
		data() {
			return {
				radioValue: 0,
				imgNum: 0,
				isSelectPicture: false,
				isBj: 0,
				tx: "https://xinian.oss-cn-beijing.aliyuncs.com/picture/20220422jksdhvjukdsghvjhkdsbvhijkdsghvuidshvuidshvb%20iudjks.jpg",
				action: httpClient.imgUrl,
				chatScriptVos: [], //聊天话术
				festivalCommodityVos: [], //节日款商品
				materialPicVos: [], //商品主图、图片、视频
				paragraphVos: [], //圈文段落富文本
				dialogVisible: false,
				title: "",
				info: {
					id: "",
					chatRecords: "",
					description: '',
					url1: "",
					video2: "",
					url6: "",
					title3: "",
					url3: "",
					video3: "",
					title8: "",
					title7: "",
					arr7: [{
						paragraph7: "",
					}],
					arr4: [{
						commodityPic: [],
						commodityTitle: "",
						commodityPrices: null,
						commodityId: "",
					}, ],
					arr9: [],
				},
				isShow: false,
				isShow2: true,
				infoRules: {
					description: [{
						required: true,
						message: "请输入图片描述",
						trigger: "change",
					}],
					url1: [{
						required: true,
						message: "请上传主图",
						trigger: "change",
					}, ],
					video2: [{
						required: true,
						message: "请上传视频",
						trigger: "change",
					}, ],
					url6: [{
						required: true,
						message: "请上传商品主图",
						trigger: "change",
					}, ],
					url3: [{
						required: true,
						message: "请上传文件",
						trigger: "change",
					}, ],
					title3: [{
						required: true,
						message: "请输入内容信息",
						trigger: "change",
					}, ],
					url3: [{
						required: true,
						message: "请上传图片",
						trigger: "change",
					}, ],
					video3: [{
						required: true,
						message: "请上传视频",
						trigger: "change",
					}, ],
					title8: [{
						required: true,
						message: "请输入富文本",
						trigger: "change",
					}, ],
					title7: [{
						required: true,
						message: "请输入内容标题",
						trigger: "change",
					}, ],
				},
				chooseType: 1,
				hideUpload: false,
				fileList: [],
				dialogImageUrl: "",
				dialogDisplay: false,
				value: 0,
				options: [{
						value: 0,
						label: "图片",
					},
					{
						value: 1,
						label: "视频",
					},
				],
				typeList: [{
						value: 1,
						label: "图片",
					},
					{
						value: 2,
						label: "视频",
					},
					{
						value: 3,
						label: "圈文",
					},
					{
						value: 4,
						label: "节日款商品",
					},
					{
						value: 5,
						label: "节日活动",
					},
					{
						value: 6,
						label: "商品主图",
					},
					{
						value: 7,
						label: "内容段落",
					},
					{
						value: 8,
						label: "富文本",
					},
					{
						value: 9,
						label: "聊天话术",
					},
				],
				list: []
			}
		},
		methods: {
			chooseRadio(num) {
				if (this.radioValue == 1) {
					this.imgNum = num
					this.isSelectPicture = true
				}
			},
			openImg(num) {
				this.imgNum = num
				this.isSelectPicture = true
			},
			getImg(e) {
				console.log(e);
				this.fileList = []
				e.split(',').forEach(item => {
					this.fileList.push({
						url: item
					})
				})
				this.info.url1 = ''
				this.info.url3 = ''
				this.info.url6 = ''
				this.info.url1 = e
				this.info.url3 = e
				this.info.url6 = e
				this.isSelectPicture = false
			},
			add(num) {
				switch (num) {
					case 1: {
						this.info.arr9.push({
							chatType: "01",
							chatContent: "",
						});
						break;
					}
					case 2: {
						this.info.arr9.push({
							chatType: "02",
							chatContent: "",
						});
						break;
					}
				}
				console.log(this.info.arr9);
			},
			del(item, index) {
				console.log(item, index);
				this.info.arr9.splice(index, 1);
			},
			//添加
			addList() {
				this.title = "请输入发布信息";
				console.log(this.title);
				this.dialogVisible = true;
				this.chooseType = 1
				Object.keys(this.info).forEach((key) => (this.info[key] = ""));
				this.info.arr7 = [{
					paragraph7: "",
				}, ];
				this.info.arr4 = [{
					commodityPic: [],
					commodityTitle: "",
					commodityPrices: null,
					commodityId: "",
				}, ];
				this.info.url1 = ''
				this.info.arr9 = [];
				this.fileList = [];
				this.hideUpload = false;
				this.typeList = [{
							value: 1,
							label: "图片",
						},
						{
							value: 2,
							label: "视频",
						},
						{
							value: 3,
							label: "圈文",
						},
						// {
						// 	value: 4,
						// 	label: "节日款商品",
						// },
						// {
						// 	value: 5,
						// 	label: "节日活动",
						// },
						// {
						// 	value: 6,
						// 	label: "商品主图",
						// },
						// {
						// 	value: 7,
						// 	label: "内容段落",
						// },
						{
							value: 8,
							label: "富文本",
						},
						// {
						// 	value: 9,
						// 	label: "聊天话术",
						// },
					],
					console.log(this.info);
			},
			//添加内容
			addCon(num) {
				switch (num) {
					case 6: {
						this.info.arr7.push({
							paragraph7: "",
						});
					}
					case 4: {
						this.info.arr4.push({
							commodityPic: [],
							commodityTitle: "",
							commodityPrices: null,
							commodityId: "",
						});
					}
				}
			},
			delCon(index, num) {
				switch (num) {
					case 6: {
						this.info.arr7.splice(index, 1);
					}
					case 4: {
						this.info.arr4.splice(index, 1);
					}
					case "4s": {
						this.info.arr4[index].commodityPic.splice(index, 1);
					}
				}
			},
			//编辑
			editorList(item) {
				console.log(item);
				let tag2 = document.getElementsByClassName('tag2')
				let tag = document.getElementsByClassName('tag')
				tag.className = "tag,hide"
				tag2.className = "tag2,hide"
				this.info.id = item.id;
				this.title = "编辑发布信息";
				this.fileList = []
				this.hideUpload = false
				this.dialogVisible = true;

				switch (item.materialType) {
					case "03": {
						this.chooseType = 1;
						this.fileList = [];
						this.hideUpload = true;
						this.fileList.push({
							url: item.url,
						});
						this.info.description = item.description
						this.info.url1 = item.url
						break;
					}
					case "04": {
						console.log(2);
						this.chooseType = 2;
						this.hideUpload = true;
						this.info.video2 = item.url;
						break;
					}
					case "02": {
						this.chooseType = 6;
						this.fileList = [];
						this.info.url6 = item.url;
						this.fileList = item.imgUrl
						if (this.fileList.length >= 9) {
							this.hideUpload = true;
						}
						break;
					}
				}
				switch (item.paragraphType) {
					case "01": {
						this.chooseType = 7;
						this.info.title7 = item.title;
						this.info.arr7 = [];
						item.paragraph2.forEach((i) => {
							this.info.arr7.push({
								paragraph7: i,
							});
						});
						console.log(this.info.arr7);
						break;
					}
					case "02": {
						this.chooseType = 8;
						this.info.title8 = item.paragraph;
						break;
					}
					case "03": {
						this.chooseType = 3;
						this.fileList = [];
						let url = []
						if (item.type2 == 0) {
							this.fileList = item.imgUrl;
							item.imgUrl.forEach(item2 => {
								url.push(item2.url)
							})
							this.info.url3 = url.join(',')
							this.value = 0;
							if (this.fileList.length >= 9) {
								this.hideUpload = true;
							}
						} else {
							this.value = 1;
							this.info.video3 = item.paragraphUrl;
						}
						this.info.title3 = item.paragraph;
						break;
					}
				}
				if (item.commodityId) {
					this.chooseType = 4;
					this.info.arr4 = [{
						commodityId: item.commodityId,
						commodityPic: [{
							url: item.commodityPic,
						}, ],
						commodityPrices: item.commodityPrices,
						commodityTitle: item.commodityTitle,
					}, ];
					this.isShow2 = false
				}
				if (item.length > 0) {
					this.chooseType = 9;
					this.info.chatRecords = item[0].chatRecords;
					this.info.arr9 = [];
					item.forEach((i) => {
						this.info.arr9.push({
							chatContent: i.chatContent,
							chatType: i.chatType,
							id: i.id,
						});
					});
				}
			},
			//删除
			delList(item) {
				console.log(item);
				let id = "";
				let type = "";
				let arr = [];
				id = item.id;
				this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					let url = "";
					if (item.materialType) {
						url = "updateMaterialPic";
						type = 1;
					}
					if (item.paragraphType) {
						url = "updateParagraph";
						type = 1;
					}
					if (item.commodityId) {
						url = "updateFestCommodity";
						type = 1;
					}
					if (item.length > 0) {
						if (item[0].chatOrder) {
							url = "updateChatScript";
							type = 2;
							// item.forEach((i) => {
							// 	arr.push({
							// 		id: i.id,
							// 		deleteStatus: 1,
							// 	});
							// });
						}
					}
					if (type == 1) {
						this.$http.post("/api/plant/knowledgeBase/" + url, {
								id: id,
								deleteStatus: 1,
							})
							.then((res) => {
								console.log(res.data);
								if (res.data.status == 0) {
									this.$message.success("删除成功");
									this.dialogVisible = false;
									this.getList(this.activeIndex);
								} else {
									this.$message.error(res.data.msg);
								}
							});
					} else {
						this.$http.post("/api/plant/knowledgeBase/" + url, {
							parentId: this.$route.query.id,
							chatModel: "01",
							chatScriptAoList: []
						}).then((res) => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.success("删除成功");
								this.dialogVisible = false;
								this.getList(this.activeIndex);
							} else {
								this.$message.error(res.data.msg);
							}
						});
					}
				});
			},
			//选择类型
			choose(item) {
				console.log(item);
				this.fileList = []
				this.hideUpload = false
				this.chooseType = item.value;
				if (this.chooseType != 1) {
					this.info.url1 = "";
				}
				if (this.chooseType != 2) {
					this.info.video2 = "";
				}
				if (this.chooseType != 3) {
					this.value = 0
					this.info.video3 = "";
					this.info.url3 = "";
					this.info.title3 = "";

				}
				if (this.chooseType != 4) {
					this.info.arr4 = [{
						commodityPic: [],
						commodityTitle: "",
						commodityPrices: null,
						commodityId: "",
					}, ];
				}
				if (this.chooseType != 6) {
					this.info.url6 = "";
				}
				if (this.chooseType != 7) {
					this.info.title7 = "";
					this.info.arr7 = [{
						paragraph7: "",
					}]
				}
				if (this.chooseType != 8) {
					this.info.title8 = "";
				}
			},
			//选择圈文的上传类型
			chooseValue() {
				this.fileList = []
				if (this.value == 0) {
					this.info.video3 = "";
				} else {
					this.info.url3 = "";
				}
				this.hideUpload = false
				console.log(this.info.video3, this.info.url3);
			},
			sumbit() {
				this.$refs.info.validate((val) => {
					if (val) {
						let url = "";
						let materialType = "";
						let paragraphType = "";
						let title = "";
						let paragraph = "";
						switch (this.chooseType) {
							case 1: {
								url = this.info.url1;
								materialType = "03";
								break;
							}
							case 2: {
								url = this.info.video2;
								materialType = "04";
								break;
							}
							case 3: {
								if (this.info.video3) {
									url = this.info.video3;
								} else {
									url = this.info.url3;
								}
								paragraph = this.info.title3;
								paragraphType = "03";
								break;
							}

							case 4: {
								if (this.title == "请输入发布信息") {
									this.info.arr4.forEach((i) => {
										i.commodityPic = i.commodityPic[0].url;
										i.parentId = this.$route.query.id;
										i.kinds = "12";
										i.commodityModel = "01";
									});
									console.log(this.info.arr4);
									this.$http
										.post(
											"/api/plant/knowledgeBase/insertFestCommodity",
											this.info.arr4
										)
										.then((res) => {
											console.log(res);
											if (res.data.status == 0) {
												this.$message.success("添加成功");
												this.dialogVisible = false;
												this.getList();
											} else {
												this.$message.error(res.data.msg);
											}
										});
								} else {
									this.info.arr4.forEach((i) => {
										i.commodityPic = i.commodityPic[0].url;
										i.parentId = this.$route.query.id;
										i.kinds = "12";
										i.id = this.info.id;
										i.commodityModel = "01";
									});
									console.log(this.info.arr4);
									this.$http
										.post(
											"/api/plant/knowledgeBase/updateFestCommodity",
											this.info.arr4[0]
										)
										.then((res) => {
											console.log(res);
											if (res.data.status == 0) {
												this.$message.success("修改成功");
												this.dialogVisible = false;
												this.getList();
											} else {
												this.$message.error(res.data.msg);
											}
										});
								}
								break;
							}

							case 6: {
								url = this.info.url6;
								materialType = "02";
								break;
							}
							case 7: {
								let arr = [];
								this.info.arr7.forEach((i) => {
									arr.push(i.paragraph7);
								});
								paragraph = arr.join("&");
								title = this.info.title7;
								paragraphType = "01";
								break;
							}
							case 8: {
								paragraph = this.info.title8;
								paragraphType = "02";
								break;
							}
							case 9: {
								for (var i = 0; i < this.info.arr9.length; i++) {
									if (this.info.arr9[i].chatContent == "") {
										this.$message.error("聊天话术未填写完整");
										return false;
									}
								}
								if (this.title == "请输入发布信息") {
									this.info.arr9.forEach((i, n) => {
										i.parentId = this.$route.query.id - 0;
										i.kinds = "12";
										i.chatModel = "01";
										i.chatRecords = "";
										i.chatOrder = n + 1;
									});
									this.$http.post(
											"/api/plant/knowledgeBase/insertChatScript",
											this.info.arr9
										)
										.then((res) => {
											console.log(res);
											if (res.data.status == 0) {
												this.$message.success("添加成功");
												this.dialogVisible = false;
												this.getList();
											} else {
												this.$message.error(res.data.msg);
											}
										});
								} else {
									this.info.arr9.forEach((i, n) => {
										i.kinds = "12";
										i.chatModel = "01";
										i.chatRecords = "";
										i.deleteStatus = 0
										i.chatOrder = n + 1;
										i.id = i.id
										i.chatRecords = this.info.chatRecords;
									});
									console.log(this.info.arr9);
									let obj = {
										parentId: this.$route.query.id, //关联ID
										chatModel: "01",
										chatScriptAoList: this.info.arr9
									}
									// return false
									this.$http.post("/api/plant/knowledgeBase/updateChatScript", obj)
										.then((res) => {
											console.log(res);
											if (res.data.status == 0) {
												this.$message.success("修改成功");
												this.dialogVisible = false;
												this.getList();
											} else {
												this.$message.error(res.data.data);
											}
										});
								}
								break;
							}
							return false;
						}
						//添加文字素材
						if (paragraphType) {
							console.log(url);
							// return false
							if (this.title == "请输入发布信息") {
								this.$http
									.post("/api/plant/knowledgeBase/insertParagraph", {
										parentId: this.$route.query.id, //关联ID
										title: title, //内容标题
										paragraphType: paragraphType, //文本类型 01:内容段落02:富文本03:圈文
										paragraphUrl: url, //视频 图片url json
										paragraph: paragraph, //内容段落
										kinds: "12",
										paragraphModel: "01", //01:节日素材
									})
									.then((res) => {
										if (res.data.status == 0) {
											this.$message.success("添加成功");
											this.dialogVisible = false;
											this.getList();
										} else {
											this.$message.error(res.data.msg);
										}
									});
							} else {
								this.$http
									.post("/api/plant/knowledgeBase/updateParagraph", {
										id: this.info.id,
										parentId: this.$route.query.id, //关联ID
										title: title, //内容标题
										paragraphType: paragraphType, //文本类型 01:内容段落02:富文本03:圈文
										paragraphUrl: url, //视频 图片url json
										paragraph: paragraph, //内容段落
										kinds: "12",
										paragraphModel: "01", //01:节日素材
									})
									.then((res) => {
										if (res.data.status == 0) {
											this.$message.success("修改成功");
											this.dialogVisible = false;
											this.getList();
										} else {
											this.$message.error(res.data.msg);
										}
									});
							}
						}

						//添加图片素材
						if (materialType) {

							if (this.title == "请输入发布信息") {
								this.$http
									.post("/api/plant/knowledgeBase/insertMaterialPic", [{
										parentId: this.$route.query.id - 0,
										url: url,
										description: this.info.description,
										materialType: materialType,
										kinds: "12",
										picModel: "01",
									}, ])
									.then((res) => {
										console.log(res.data);
										if (res.data.status == 0) {
											this.$message.success("添加成功");
											this.dialogVisible = false;
											this.getList();
										} else {
											this.$message.error(res.data.msg);
										}
									});
							} else {
								this.$http
									.post("/api/plant/knowledgeBase/updateMaterialPic", {
										id: this.info.id,
										parentId: this.$route.query.id - 0,
										url: url,
										description: this.info.description,
										materialType: materialType,
										kinds: "12",
										picModel: "01",
									})
									.then((res) => {
										console.log(res.data);
										if (res.data.status == 0) {
											this.$message.success("修改成功");
											this.dialogVisible = false;
											this.getList();
										} else {
											this.$message.error(res.data.msg);
										}
									});
							}
						}
					}
				});
			},
			//上传图片
			getPictrueURL(res, file, fileList) {
				switch (this.chooseType) {
					case 1: {
						console.log(res);
						this.info.url1 = res.data;
						this.hideUpload = fileList.length >= 1;
						break;
					}
					case 2: {
						console.log(res);
						this.info.video2 = res.data;
						break;
					}

					case 3: {
						switch (this.value) {
							case 0: {
								if (this.info.url3[this.info.url3.length - 1] == "") {
									this.info.url3 = res.data;
								} else {
									if (this.info.url3.length > 0) {
										this.info.url3 += "," + res.data;
									} else {
										this.info.url3 = res.data;
									}
								}
								this.hideUpload = fileList.length >= 9;
								break;
							}
							case 1: {
								this.info.video3 = res.data;
								break;
							}
						}
						break;
					}

					case 6: {
						if (this.info.url6[this.info.url6.length - 1] == "") {
							this.info.url6 = res.data;
						} else {
							if (this.info.url6.length > 0) {
								this.info.url6 += "," + res.data;
							} else {
								this.info.url6 = res.data;
							}
						}
						this.hideUpload = fileList.length >= 9;
						break;
					}
				}
			},
			//预览图片
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogDisplay = true;
			},
			// 图片删除
			handleRemove(file, fileList) {
				switch (this.chooseType) {
					case 1: {
						let files = this.info.url1.split(",");
						files.splice(files.indexOf(file.url), 1);
						this.info.url1 = files.length === 0 ? "" : files.join(",");
						this.hideUpload = fileList.length >= 1;
						break;
					}
					case 2: {
						console.log(1);
						this.info.video2 = "";
						break;
					}

					case 3: {
						switch (this.value) {
							case 0: {
								let files = this.info.url3.split(",");
								console.log(files);
								files.splice(files.indexOf(file.url), 1);
								this.info.url3 = files.length === 0 ? "" : files.join(",");
								this.hideUpload = fileList.length >= 9;
								this.fileList = fileList
								break;
							}
							case 1: {
								this.info.video3 = "";
								this.hideUpload = fileList.length >= 1;
								break;
							}
						}
						break;
					}

					case 6: {
						let files = this.info.url6.split(",");
						console.log(files);
						files.splice(files.indexOf(file.url), 1);
						this.info.url6 = files.length === 0 ? "" : files.join(",");
						this.hideUpload = fileList.length >= 9;
						break;
					}
				}
			},
			// 图片预览dialog关闭时的回调
			imagePrevClosed() {
				this.dialogImageUrl = "";
			},
			getPictrueURL2(obj, res, file, fileList) {
				var index = obj.index;
				this.info.arr4[index].commodityPic.push({
					url: res.data,
				});
				console.log(this.info.arr4);
			},
			handleRemove2(obj, file, fileList) {
				let index = obj.index;
				this.info.arr4[index].commodityPic = [];
				this.hideUpload = false;
			},
			getList() {
				this.$http.post("/api/plant/knowledgeBase/selectMaterialByKind", {
					id: this.$route.query.id,
					kinds: "12",
					model: '01'
				}).then(res => {
					var arr = res.data.data.chatScriptVos;
					var map = {},
						dest = [];
					for (var i = 0; i < arr.length; i++) {
						var ai = arr[i];
						if (!map[ai.chatRecords]) {
							dest.push({
								chatRecords: ai.chatRecords,
								data: [ai]
							});
							map[ai.chatRecords] = ai;
						} else {
							for (var j = 0; j < dest.length; j++) {
								var dj = dest[j];
								if (dj.chatRecords == ai.chatRecords) {
									dj.data.push(ai);
									break;
								}
							}
						}
					}
					console.log(dest);
					this.chatScriptVos = []
					dest.forEach(i => {
						this.chatScriptVos.push(i.data)
					})
					console.log(this.chatScriptVos);
					this.festivalCommodityVos = res.data.data.festivalCommodityVos
					let materialPicVos = res.data.data.materialPicVos
					if (materialPicVos.length > 0) {
						materialPicVos.forEach(i => {
							let imgUrl = []
							if (i.materialType == "02") {
								imgUrl = i.url.split(',')
								i.imgUrl = []
								if (imgUrl.length > 0) {
									imgUrl.forEach(item => {
										i.imgUrl.push({
											url: item
										})
									})
								}
							}

						})
					}
					this.materialPicVos = materialPicVos
					let paragraphVos = res.data.data.paragraphVos
					if (paragraphVos.length > 0) {
						paragraphVos.forEach(i => {
							if (i.paragraphType == "01") {
								i.paragraph2 = [];
								i.paragraph2 = i.paragraph.split("&");
							}
							if (i.paragraphType == "03") {
								i.type2 = ''
								if (i.paragraphUrl.substring(i.paragraphUrl.length - 4) ==
									".mp4") {
									i.type2 = 1
								} else {
									i.type2 = 0
									i.imgUrl = [];
									i.paragraphUrl.split(",").forEach((item) => {
										i.imgUrl.push({
											url: item,
										});
									});
								}
							}
						})
					}
					this.paragraphVos = paragraphVos
					console.log('圈文，富文本，段落', this.paragraphVos);
					console.log('聊天话术', this.chatScriptVos);
					console.log("节日款商品", this.festivalCommodityVos);
					console.log('图片，视频，商品主图', this.materialPicVos);
				})
			}
		},
		created() {
			this.getList()

		}
	}
</script>

<style scoped>
	.date {
		width: 30%;
		height: 50px;
		text-align: center;
		line-height: 50px;
		margin-left: 5%;
		background-color: rgba(218, 218, 218, 0.9);
		color: #fdfffd;
	}

	.box {
		width: 100%;
		height: auto
	}

	.box .list {
		width: 100%;
		height: auto;
	}

	.box .list .time {
		width: 80%;
		height: 30px;
		margin: 0 auto;
		background-color: #dadada;
		text-align: center;
		line-height: 30px;
	}

	.box .list .con {
		width: 80%;
		height: 500px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.box .btn {
		width: 100%;
		height: 50px;
		text-align: center;
		line-height: 50px;
		border-top: 1px solid #000;
	}

	.tag {
		width: 100px;
		background-color: #fff;
		margin-left: 10px;
		text-align: center;
		color: #000;
		border: 1px solid #000;
	}

	.tag2 {
		width: 100px;
		background-color: #209cd3;
		margin-left: 10px;
		text-align: center;
		color: #fff;
		border: 1px solid #209cd3;

	}

	/deep/.hide .el-upload--picture-card {
		display: none;
	}
</style>
